"use strict";

var STORAGE_KEY = "zone-selector-first-visit-dismissed";
var ZONE_SELECTOR_DISMISSED_KEY = "zone-selector-modal-dismissed";
var LOG_PREFIX = "[ZoneSelectorFirstVisit]";

function hasDismissedZoneSelectorModal() {
    return localStorage.getItem(ZONE_SELECTOR_DISMISSED_KEY) === "true";
}

function hasSeenFirstVisitModal() {
    return sessionStorage.getItem(STORAGE_KEY) === "true";
}

function markFirstVisitModalAsSeen() {
    sessionStorage.setItem(STORAGE_KEY, "true");
}

function positionModalNearLocation($modal) {
    var $modalDialog = $modal.find(".modal-dialog");
    var isMobile = window.innerWidth < 992;
    var $selector = isMobile ? $(".region-mobile") : $(".region-selector-header");

    if ($selector.length === 0) {
        $selector = $(".region-selector-header, .region-mobile").first();
    }

    var viewportWidth = $(window).width();
    var sideMargin = 16;

    if ($selector.length === 0) {
        $modalDialog.css({
            position: "fixed",
            top: "80px",
            left: sideMargin + "px",
            transform: "none",
            margin: "0"
        });
        return;
    }

    var offset = $selector.offset();
    var height = $selector.outerHeight();
    var scrollTop = $(window).scrollTop();
    var topPosition = Math.max(5, offset.top - scrollTop + height + 2);

    // Clamp horizontally so the modal never overflows the viewport. This is critical on
    // mobile, where anchoring at the selector's offset.left with a 90% width would push the
    // dialog off the right edge.
    var dialogWidth = $modalDialog.outerWidth() || Math.min(420, viewportWidth - (sideMargin * 2));
    var leftPosition = offset.left;
    var maxLeft = viewportWidth - dialogWidth - sideMargin;

    if (leftPosition > maxLeft) {
        leftPosition = maxLeft;
    }
    if (leftPosition < sideMargin) {
        leftPosition = sideMargin;
    }

    $modalDialog.css({
        position: "fixed",
        top: topPosition + "px",
        left: leftPosition + "px",
        transform: "none",
        margin: "0"
    });
}

function removeModalBlockers() {
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
}

function showFirstVisitModal() {
    var $modal = $(".js-zone-selector-first-visit-modal");

    if ($modal.length === 0) {
        console.log(LOG_PREFIX, "modal not found in DOM");
        return;
    }

    console.log(LOG_PREFIX, "showing modal");
    $modal.addClass("is-positioning");
    $modal.modal({ backdrop: false, keyboard: false, show: true });
    removeModalBlockers();

    $modal.on("shown.bs.modal", function () {
        positionModalNearLocation($modal);
        removeModalBlockers();
        $modal.removeClass("is-positioning");

        $(window).on("resize.firstVisitModal scroll.firstVisitModal", function () {
            positionModalNearLocation($modal);
        });
    });

    $modal.on("hidden.bs.modal", function () {
        $(window).off("scroll.firstVisitModal resize.firstVisitModal");
        removeModalBlockers();
        $modal.removeClass("is-positioning");
    });
}

function initFirstVisitModalListeners() {
    var $modal = $(".js-zone-selector-first-visit-modal");

    if ($modal.length === 0) {
        console.log(LOG_PREFIX, "listeners not attached: modal not found");
        return;
    }

    $modal.find(".js-btn-keep-location").on("click", function (e) {
        e.preventDefault();
        console.log(LOG_PREFIX, "clicked keep location");
        markFirstVisitModalAsSeen();
        localStorage.setItem(ZONE_SELECTOR_DISMISSED_KEY, "true");
        $modal.modal("hide");
    });

    $modal.find(".js-btn-edit-location").on("click", function (e) {
        e.preventDefault();
        console.log(LOG_PREFIX, "clicked edit location");
        markFirstVisitModalAsSeen();
        $modal.modal("hide");

        setTimeout(function () {
            if (hasDismissedZoneSelectorModal()) {
                console.log(LOG_PREFIX, "not opening region modal: dismissed flag true");
                return;
            }
            var $regionModal = $(".js-region-selector-modal");
            if ($regionModal.length > 0) {
                console.log(LOG_PREFIX, "opening region selector modal");
                $regionModal.modal("show");
            } else {
                console.log(LOG_PREFIX, "region selector modal not found in DOM");
            }
        }, 300);
    });

    $modal.on("hidden.bs.modal", function () {
        markFirstVisitModalAsSeen();
    });
}

function checkAndShowFirstVisitModal() {
    var seenInSession = hasSeenFirstVisitModal();
    var dismissedInLocalStorage = hasDismissedZoneSelectorModal();
    var currentPath = window.location.pathname.toLowerCase();
    var isCheckoutOrCart = currentPath.indexOf("/checkout") !== -1 || currentPath.indexOf("/cart") !== -1;

    console.log(LOG_PREFIX, "validation", {
        path: currentPath,
        seenInSession: seenInSession,
        dismissedInLocalStorage: dismissedInLocalStorage,
        isCheckoutOrCart: isCheckoutOrCart
    });

    if (seenInSession || dismissedInLocalStorage) {
        console.log(LOG_PREFIX, "blocked by session/localStorage flags");
        return;
    }

    if (isCheckoutOrCart) {
        console.log(LOG_PREFIX, "blocked by page type (checkout/cart)");
        return;
    }

    console.log(LOG_PREFIX, "eligible to show in 500ms");
    setTimeout(function () {
        showFirstVisitModal();
    }, 500);
}

module.exports = {
    init: function () {
        console.log(LOG_PREFIX, "init");
        initFirstVisitModalListeners();
        checkAndShowFirstVisitModal();
    }
};
